<div #imageViewer class="image-viewer">
    <img #imageView [src]="safeFileUrl" (load)="onImageLoaded($event)" />
    <div class="button-container">
        <button id="zoomIn" mat-mini-fab class="basic-button" aria-label="Zoomer" matTooltip="Zoomer" matTooltipPosition="below" (click)="onZoomIn($event)">
            <fa-icon [icon]="zoomInIcon"></fa-icon>
        </button>
        <button id="zoomOut" mat-mini-fab class="basic-button" aria-label="Dezoomer" matTooltip="Dezoomer" matTooltipPosition="below" (click)="onZoomOut($event)">
            <fa-icon [icon]="zoomOutIcon"></fa-icon>
        </button>
        <button id="download" mat-mini-fab class="basic-button" aria-label="Télécharger" matTooltip="Télécharger" matTooltipPosition="below" (click)="onDownloadRequested()">
            <fa-icon [icon]="downloadIcon"></fa-icon>
        </button>
    </div>
</div>
